import request from '@/utils/request'

export function listArea(parentId) {
    if (parentId == undefined) {
        parentId = 0;
    }
    return request({
        url: `/info/area/${parentId}`,
        method: 'get'
    })
}